<script>

import Vue from "vue";

import Layout from "../../layouts/main";
import DatePicker from "vue2-datepicker";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";  

import axios from "axios";
import { required } from "vuelidate/lib/validators";
import { requiredIf } from "vuelidate/lib/validators";

/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Posts List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, DatePicker, Multiselect },
  data() {
    return {
      gridData: {
        data: [],
        total: 0,
      },
      title: "Posts List",
      model: "Post",
      items: [
        {
          text: "Dashboard",
          href: "/dashboard"
        },
        {
          text: 'Posts List',
          active: true
        }
      ],
      submitted: false,
      theads: ["Posted By", "Room", "Post", "Subject", "Action"],
      isLoadingGetList: false,
      isLoadingPost: false,
      data: {
        title: null,
        description: null,
        subject_id: 0,
        room_id: 0,
        room_ids: [],
        item_id: 0,
        year_id: null,
        date: new Date(),
        attachments: [],
        protected_files: [],
        is_announcement: false,
      },
      filter: {
        paginate_count: 10,
        page: 1,
      },
      token: null,
      itemList: [],
      subjectList: [],
      yearList: [],
      roomList: [],
      list_error_messages: [],
      file_error_messages: [],
      errors: {
        room_ids: [],
        subject_id: false
      },
      showAdvancedInput: false,
      select_key: 0,
    };
  },
  validations: {
    data: {
      date: { required },
      description: { required },
      year_id: { required }
    },
  },
  async mounted(){
    this.token = await localStorage.getItem('authToken')

    this.getItemList();
    this.getSubjectList();
    this.getYearList();
    this.getRoomList();

    if(this.$route.params.date){
      this.data.date = new Date(this.$route.params.date);
    } else {
      let date = new Date();
      this.data.date = new Date(date.setDate(date.getDate() + 2))
    }
  },
  watch: {
    'filter.page': function(){
      this.getList();
    }
  },
  methods: {
    disabledRange: function (date) {
      if(this.$store.getters['auth/loggedIn'].role_id !== 2){
        var today = new Date();
        // Set time to the beginning of the day to ensure accurate comparison
        today.setHours(0, 0, 0, 0);
  
        var tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 2);
  
        return date < tomorrow;
      }
    },
    getItemList(){
      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/public/item')
      .then(res => {
        this.itemList = res.data.data;

        this.itemList.unshift({
          id: 0,
          name: 'Select one of the items'
        });
      })
    },
    getSubjectList(){
      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/public/subject')
      .then(res => {
        this.subjectList = res.data.data;

        this.subjectList.unshift({
          id: 0,
          name: 'Select one of the subjects'
        });
      })
    },
    getYearList(){
      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/public/year')
      .then(res => {
        this.yearList = res.data.data;
        
        this.yearList.forEach(year => {
          if(year.is_active){
            this.data.year_id = year.id;
          }
        })
      })
    },
    getRoomList(){
      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/room/getIndex', {
        headers: {
          Authorization: 'Bearer ' + this.token
        }
      })
      .then(res => {
        this.roomList = res.data.data;

        // this.roomList.unshift({
        //   id: 0,
        //   name: 'Select one of the rooms'
        // });
      })
    },
    onChangeAnnouncement(){
      if(this.data.is_announcement){
        this.data.subject_id = 0;
        this.data.item_id = 0;

        if(this.$store.getters['auth/isAdmin']) {
          var index = this.roomList.findIndex(room => room.id == 'all');
          if(index == -1){
            this.roomList.push({
              id: 'all',
              name: 'All Rooms'
            })
          }
        }
      } else {
        var removeIndex = this.roomList.findIndex(room => room.id == 'all');
        if(removeIndex > -1){
          this.roomList.splice(removeIndex, 1);
        }
      }
    },
    onChangeRoom(value, id){
      this.errors.room_ids = []

      if(value.id == 'all'){
        this.data.subject_id = 0;
        this.data.item_id = 0;
        Swal.fire("You have selected All Rooms", "You wont be able to change the date once posted!", "warning");
      }

      this.select_key++
    },
    formSubmit(e){

      this.submitted = true;
      this.list_error_messages = [];
      this.file_error_messages = [];

      if(this.data.room_ids.length < 1){
        this.errors.room_ids = ['Select Room of the ' + this.model];
      }

      if(!this.data.subject_id){
        this.errors.subject_id = true;
      }

      if(!this.data.item_id){
        this.errors.item_id = true
      }

      this.$v.$touch();

      if(this.$v.$invalid || this.errors.room_ids.length){
        return;
      }

      if(this.data.is_announcement && this.data.room_id == 'all'){
        Swal.fire({
          title: "Create for all rooms?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Yes, create for all rooms!"
        }).then(result => {
          if (result.value) {
            console.log('post all rooms')
            this.startPost();
          }
        });
      } else {

        if(this.data.is_announcement){
          this.data.subject_id = 0;
          this.data.item_id = 0;
          console.log('start post announcement')
          this.startPost();

          return ;
        }

        if(this.errors.subject_id || this.errors.item_id){
          return ;
        }
        
        console.log('start post');
        this.startPost();
      }
    },
    startPost(){
      this.isLoadingPost = true;

      let formData = new FormData();
      formData.append('title', this.data.title)

      if(this.data.description){
        formData.append('description', this.data.description)
      }

      this.data.room_ids.forEach(room => {
        formData.append('room_ids[]', room.id)
      })
      
      // formData.append('room_id', this.data.room_id)
      formData.append('year_id', this.data.year_id)
      formData.append('date', this.data.date)

      if(this.data.is_announcement){
        formData.append('is_announcement', this.data.is_announcement)
      } else {
        if(this.data.subject_id > 0){
          formData.append('subject_id', this.data.subject_id)
        }
        
        if(this.data.item_id > 0){
          formData.append('item_id', this.data.item_id)
        }
      }

      let max_size = 2 * 1024 * 1024; //2MB
      let max_size_string = '2MB';
      if(this.data.is_announcement){
        max_size = 20 * 1024 * 1024; //20MB
        max_size_string = '20MB';
      }

      for(let i = 0; i < this.data.attachments.length; i++){
        if(this.data.attachments[i].size > max_size){
          this.file_error_messages.push('File ' + this.data.attachments[i].name + ' is too large. Max. file size is ' + max_size_string);
          return;
        } else {
          formData.append('attachments[]', this.data.attachments[i])
        }
      }

      for(let i = 0; i < this.data.protected_files.length; i++){
        if(this.data.protected_files[i].size > max_size){
          this.file_error_messages.push('File ' + this.data.protected_files[i].name + ' is too large. Max. file size is ' + max_size_string);
          return;
        } else {
          formData.append('protected_files[]', this.data.protected_files[i])
        }
      }

      Vue.swal({
        icon: "info",
        title: "Loading ...",
        showConfirmButton: false,
        closeOnEsc: false,
        closeOnClickOutside: false,
      });

      axios.post(process.env.VUE_APP_API + '/post', formData, {
        headers: {
          Authorization: 'Bearer ' + this.token,
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(res => {
        Vue.swal.close();

        Swal.fire("Success", "Post has been created", "success");
        // this.$router.push({ name: 'Posts List' });
        this.$router.go(-1);
      })
      .catch(err => {
        Vue.swal.close();

        if('response' in err){
          if('data' in err.response){
            if('message' in err.response.data){
              this.list_error_messages.push(err.response.data.message)
            }
          }
        }
      })
      .finally(() => {
        this.isLoadingPost = false;
      })
    },
    onClickGoBack(){
      this.$router.go(-1);
    },
    onChangeFileInput(e, data_type = 'attachments'){
      //validate max file size 2mb per each file
      let files = e.target.files;
      let max_size = 2 * 1024 * 1024; //2MB
      let max_size_string = '2MB';

      if(this.data.is_announcement){
        max_size = 20 * 1024 * 1024; //20MB
        max_size_string = '20MB';
      }

      this.file_error_messages = []

      if(this.data[data_type].length + files.length > 5){
        this.file_error_messages.push('You can only upload maximum 4 files');
        //reset input
        e.target.value = '';
        return;
      }
      
      for(let i = 0; i < files.length; i++){
        let size = files[i].size;
        if(size > max_size){
          this.file_error_messages.push('File ' + files[i].name + ' is too large. Max. file size is ' + max_size_string);
          continue;
        } else {
          this.data[data_type].push(files[i])
        }
      }
    },
    renderFileIcon(attachment){
      let filetype = attachment.type;
      
      if(filetype.includes('image')){
        return 'bx bxs-file-image text-primary';
      } else if(filetype.includes('pdf')){
        return 'bx bxs-file-pdf text-danger';
      } else if(filetype.includes('word')){
        return 'bx bxs-file-doc text-primary';
      } else if(filetype.includes('excel')){
        return 'bx bxs-file-excel text-success';
      } else if(filetype.includes('powerpoint')){
        return 'bx bxs-file text-danger';
      } else {
        return 'bx bxs-file text-dark';
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card plan-box">
          <div class="card-body">
            <div class="col-lg-10 col-12 text-center plan-btn mb-3">
              <a
                @click="showAdvancedInput = !showAdvancedInput"
                class="btn btn-primary btn-sm position-relative"
              >{{ showAdvancedInput ? 'Hide' : 'Show' }} Advanced Options</a>
            </div>

            <div class="col mt-2">
              <form class="needs-validation" @submit.prevent="formSubmit">
                <div class="row">
                  <div class="col-lg-10 col-12 bg-light mb-2" v-if="showAdvancedInput">
                    <div class="mb-3 mt-2">
                      <label for="inputYear">Select Year <span class="text-danger small">*</span></label>
                      <select
                        id="inputYear"
                        v-model="data.year_id"
                        class="form-control">
                        <option :value="year.id" v-for="(year, index) in yearList" :key="`year_${index}`">{{year.name}}</option>
                      </select>
                      <div v-if="submitted && $v.data.year_id.$error" class="invalid-feedback">
                        <span v-if="!$v.data.year_id.required">Select Year.</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mb-3">
                    <div class="mb-2"><strong>To note:</strong></div>
                    <div class="alert alert-warning">
                      <div>1. You can only post for upcoming date, min H + 2</div>
                      <div>2. Each room should only have 4 posts in a day</div>
                      <div>3. Each post could attach up to 4 doc (pdf, picture, excel or doc files)</div>
                    </div>
                  </div>
                  <div class="col-lg-10 col-12" v-if="$store.getters['auth/isAdmin']">
                    <div class="form-check form-checkbox-outline form-check-primary mb-3">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="inputAnnouncement"
                          v-model="data.is_announcement"
                          @change="onChangeAnnouncement()"
                        />
                        <label class="form-check-label" for="inputAnnouncement">
                          Tick this box if you want to make this post as an announcement
                        </label>
                        <div class="text-muted">
                          <small>Announcement can be posted for all rooms. Once you have selected all rooms, <span class="text-danger fw-bolder">you can not revert back!</span></small>
                        </div>
                      </div>
                  </div>
                  <div class="col-lg-5 col-12">
                    <div class="mb-3">
                      <label for="inputDate">Date <span class="text-danger small">*</span></label>
                      <date-picker 
                        v-model="data.date" 
                        :first-day-of-week="1" 
                        :disabled-date="disabledRange"
                        lang="en"
                        :class="{
                          'is-invalid': submitted && $v.data.date.$error,
                        }"
                      >
                      </date-picker>
                      <div v-if="submitted && $v.data.date.$error" class="invalid-feedback">
                        <span v-if="!$v.data.date.required">Select Date of the {{ model }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5 col-12">
                    <div class="mb-3">
                      <label for="inputRoom">Select Room <span class="text-danger small">*</span></label>
                      <multiselect
                        id="inputRoom"
                        v-model="data.room_ids"
                        :options="roomList"
                        label="name"
                        :multiple="true"
                        track-by="id"
                        @select="onChangeRoom"
                        :key="`room_${select_key}`"
                      ></multiselect>
                      <div v-if="submitted && errors.room_ids.length" class="text-danger">
                        <span>Select Room of the {{ model }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5 col-12" v-if="!data.is_announcement">
                    <div class="mb-3">
                      <label for="inputSubject">Select Subject <span class="text-danger small">*</span></label>
                      <select
                        id="inputSubject"
                        v-model="data.subject_id"
                        @change="errors.subject_id = false"
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && errors.subject_id,
                        }"
                      >
                        <option :value="subject.id" v-for="(subject, index) in subjectList" :disabled="!subject.id" :key="`subject_${index}`">{{subject.name}}</option>
                      </select>
                      <div v-if="submitted && errors.subject_id" class="invalid-feedback">
                        <span v-if="errors.subject_id">Select Subject of the {{ model }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5 col-12" v-if="!data.is_announcement">
                    <div class="mb-3">
                      <label for="inputItem">Select Item <span class="text-danger small">*</span></label>
                      <select
                        id="inputItem"
                        v-model="data.item_id"
                        @change="errors.item_id = false"
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && errors.item_id,
                        }"
                      >
                        <option :value="item.id" v-for="(item, index) in itemList" :disabled="!item.id" :key="`item_${index}`">{{item.name}}</option>
                      </select>
                      <div v-if="submitted && errors.item_id" class="invalid-feedback">
                        <span v-if="errors.item_id">Select Item of the {{ model }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-lg-10 col-12 ml-lg-auto">
                    <div class="mb-3">
                      <label for="inputField1">Title <span class="text-danger small">*</span></label>
                      <input
                        id="inputField1"
                        v-model="data.title"
                        type="text"
                        class="form-control"
                        placeholder="Title of the post"
                        :class="{
                          'is-invalid': submitted && $v.data.title.$error,
                        }"
                      />
                      <div v-if="submitted && $v.data.title.$error" class="invalid-feedback">
                        <span v-if="!$v.data.title.required">Title is required.</span>
                      </div>
                    </div>
                  </div> -->
                  <div class="col-lg-10 col-12 ml-lg-auto">
                    <div class="mb-3">
                      <label for="inputDescription">Note <span class="text-danger small">*</span></label>
                      <textarea
                        id="inputDescription"
                        v-model="data.description"
                        class="form-control"
                        rows="7"
                        :class="{
                          'is-invalid': submitted && $v.data.description.$error,
                        }"
                        placeholder="Ex: To complete task from Page 20 to Page 30"
                      ></textarea>
                      <div v-if="submitted && $v.data.description.$error" class="invalid-feedback">
                        <span v-if="!$v.data.description.required">Note is required.</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-10 col-12 ml-lg-auto">
                    <div class="mb-3">
                      <label for="formAttachment" class="form-label">Attachment</label>
                      <input class="form-control" type="file" id="formAttachment" multiple @change="(e) => onChangeFileInput(e, 'attachments')" />
                      <div class="mt-1 text-muted small">Max. 4 files with maximum file size {{ data.is_announcement ? '20MB' : '2MB' }} each</div>
                    </div>
                    <div v-for="(attachment, index) in data.attachments" :key="`attachment_${index}`" class="mb-2">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="text-truncate">
                          <i :class="renderFileIcon(attachment)"></i> {{ attachment.name }}
                          <button type="button" class="btn btn-link btn-sm text-danger" @click="data.attachments.splice(index, 1)">Remove</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="col-lg-10 col-12 ml-lg-auto">
                    <div class="mb-3">
                      <label for="formProtectedFiles" class="form-label">Protected Files</label>
                      <input class="form-control" type="file" id="formProtectedFiles" multiple @change="(e) => onChangeFileInput(e, 'protected_files')" />
                      <div class="mt-1 text-muted small">Max. 4 files with maximum file size {{ data.is_announcement ? '20MB' : '2MB' }} each</div>
                    </div>
                    <div v-for="(protected_file, index) in data.protected_files" :key="`protected_file_${index}`" class="mb-2">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="text-truncate">
                          <i :class="renderFileIcon(protected_file)"></i> {{ protected_file.name }}
                          <button type="button" class="btn btn-link btn-sm text-danger" @click="data.protected_files.splice(index, 1)">Remove</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <b-alert show variant="danger" v-for="(err, index) in file_error_messages" :key="`file_error_${index}`">
                      {{ err }}
                    </b-alert>
                  </div>
                  
                </div>

                <div class="col mb-3">
                  <b-alert class="mb-1" show variant="danger" v-for="(err, index) in list_error_messages" :key="`list_error_${index}`">
                    {{ err }}
                  </b-alert>
                </div>
                
                <div class="col-12 d-flex mt-3">
                  <button :disabled="isLoadingPost" class="btn btn-primary me-4" type="submit">Submit</button>
                  <button type="button" :disabled="isLoadingPost" class="btn btn-light" @click="onClickGoBack()">Go Back</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>